import React from 'react';

import Logo from '../common/Logo';

const Auth = (props) => {
  const { children } = props;

  return (
    <div className="auth">
      <div className="auth-banner">
        <div className="auth-media">
          <Logo additionalClassName="big" />
        </div>
      </div>
      <div className="auth-content">
        { children }
      </div>
    </div>
  );
};

export default Auth;
